import React, { useState } from 'react';
import './SetupBanner.css';
import Icon from './Icon';
import { setupProgress } from './setupProgress';

// A gentle, dismissible "finish setting up" nudge shown at the top of the agent's
// screens — but ONLY while setup is incomplete AND not dismissed. Once the agent
// finishes all steps or clicks the ×, it disappears (dismissal persists per account
// in localStorage) and the checklist lives only behind Profile → Getting Started.

const dismissKey = (id) => `ira_setup_dismissed_${id || ''}`;

function SetupBanner({ agent = {}, scope, onOpen }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(dismissKey(agent.id)) === '1'; } catch { return false; }
  });
  const { doneCount, total, allDone } = setupProgress(agent, scope);

  if (dismissed || allDone) return null;

  function dismiss() {
    try { localStorage.setItem(dismissKey(agent.id), '1'); } catch {}
    setDismissed(true);
  }

  return (
    <div className="setup-banner">
      <div className="setup-banner-left">
        <span className="setup-banner-icon"><Icon name="check-circle" size={20} /></span>
        <div className="setup-banner-text">
          <strong>Finish setting up iBetterAgent</strong>
          <span className="setup-banner-sub">{doneCount} of {total} steps done — a few minutes puts your follow-ups on autopilot.</span>
        </div>
      </div>
      <div className="setup-banner-actions">
        <button type="button" className="setup-banner-cta" onClick={onOpen}>Finish setup <Icon name="chevron-right" size={15} /></button>
        <button type="button" className="setup-banner-x" title="Dismiss" aria-label="Dismiss" onClick={dismiss}><Icon name="close" size={16} /></button>
      </div>
    </div>
  );
}

export default SetupBanner;
